import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #E0E0E0;
  gap: 10px;
  padding: 10px;
`;

export const Headline = styled.div`
  color: #B9A300;
  font-size: 12px;
  weight: 400;
`;

export const Caveat = styled.div`
  color: #000;
  font-weight: 400;
  font-family: Inter;
  font-size: 12px;
`;
